import moment from 'moment'

export type ExtensionRequestListItem = {
  id: number
  staffName: string
  staffEmail: string
  staffNumber: string
  reason: string
  estimatedTime: number
  submittedAt: string
  submittedBy: string
}

function readString(value: unknown): string {
  if (typeof value === 'string') return value
  if (value == null) return ''
  return String(value)
}

function normalizeExtensionItem(raw: unknown): ExtensionRequestListItem | null {
  if (!raw || typeof raw !== 'object') return null
  const o = raw as Record<string, unknown>
  const id = Number(o.id ?? o.Id)
  if (!Number.isFinite(id)) return null
  const estimatedTime = Number(o.estimatedTime ?? o.EstimatedTime)
  return {
    id,
    staffName: readString(o.staffName ?? o.StaffName),
    staffEmail: readString(o.staffEmail ?? o.StaffEmail),
    staffNumber: readString(o.staffNumber ?? o.StaffNumber),
    reason: readString(o.reason ?? o.Reason),
    estimatedTime: Number.isFinite(estimatedTime) ? estimatedTime : 0,
    submittedAt: readString(o.submittedAt ?? o.SubmittedAt),
    submittedBy: readString(o.submittedBy ?? o.SubmittedBy),
  }
}

export function normalizeExtensionRequestsList(data: unknown): ExtensionRequestListItem[] {
  if (Array.isArray(data)) {
    return data
      .map(normalizeExtensionItem)
      .filter((x): x is ExtensionRequestListItem => x != null)
  }
  if (!data || typeof data !== 'object') return []
  const nested =
    (data as Record<string, unknown>).result ?? (data as Record<string, unknown>).Result
  if (Array.isArray(nested)) {
    return nested
      .map(normalizeExtensionItem)
      .filter((x): x is ExtensionRequestListItem => x != null)
  }
  return []
}

export function formatExtensionEstimatedTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds <= 0) return '-'
  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  if (hours > 0) return `${hours}h ${minutes}m`
  return `${minutes}m`
}

/** Display only — API returns submittedAt already in appointment timezone. */
export function formatExtensionSubmittedAt(
  value: string,
  format = 'MMM D, YYYY h:mm A'
): string {
  if (!value) return '-'
  const parsed = moment(value)
  return parsed.isValid() ? parsed.format(format) : value
}
